import type { QueryClient } from "@tanstack/react-query"
import {
  createRootRouteWithContext,
  Outlet,
  type ErrorComponentProps,
} from "@tanstack/react-router"

import { AppUpdateBanner } from "@/components/common/app-update-banner"
import { RouteError } from "@/components/common/route-error"
import { Toaster } from "@/components/ui/sonner"

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()(
  {
    component: RootLayout,
    errorComponent: RootError,
  }
)

function RootError(props: ErrorComponentProps) {
  return (
    <div className="flex min-h-svh flex-col">
      <RouteError {...props} />
    </div>
  )
}

function RootLayout() {
  return (
    <div className="flex min-h-svh flex-col">
      <AppUpdateBanner />
      <Outlet />
      <Toaster position="bottom-right" />
    </div>
  )
}
